import { Box } from '@chakra-ui/react'
import { ResponsiveContainer } from 'recharts'

export interface ChartFrameProps {
  children: React.ReactNode
  height?: number
  printWidth?: number
  ariaLabel: string
}

export function ChartFrame({ children, height = 280, printWidth, ariaLabel }: ChartFrameProps) {
  if (printWidth != null) {
    return (
      <Box data-viz-frame role="img" aria-label={ariaLabel} style={{ width: printWidth }} maxW="100%" overflowX="auto">
        {children}
      </Box>
    )
  }
  return (
    <Box data-viz-frame role="img" aria-label={ariaLabel} maxW="100%" overflowX="auto">
      <ResponsiveContainer width="100%" height={height}>
        {children as React.ReactElement}
      </ResponsiveContainer>
    </Box>
  )
}
